/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonAddress
 */
export interface JsonAddress {
    /**
     * 
     * @type {string}
     * @memberof JsonAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonAddress
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonAddress
     */
    zip?: string;
}

export function JsonAddressFromJSON(json: any): JsonAddress {
    return JsonAddressFromJSONTyped(json, false);
}

export function JsonAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
    };
}

export function JsonAddressToJSON(value?: JsonAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city': value.city,
        'country': value.country,
        'street': value.street,
        'zip': value.zip,
    };
}

